module.exports = __webpack_public_path__ + "img/LKA.bf2d5e39.gif";